import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import { FAQState } from './types'
import { FaqService } from '../../services/faq/FaqService'
import { FAQDetail } from '../../services/faq/types'

export const MAX_FAQS = 8

const initialState: FAQState = {
  isCreateOrUpdateFAQLoading: false,
  isGetAllFAQsLoading: false
}

const slice = createSlice({
  name: 'faq',
  initialState,
  reducers: {
    onChangeFAQ: (
      state,
      action: PayloadAction<{
        field: keyof FAQDetail
        value: string
        index: number
      }>
    ) => {
      const index = action.payload.index
      const value = action.payload.value
      const field = action.payload.field
      if (state.faqs) {
        state.faqs.faqs[index] = {
          ...state.faqs.faqs[index],
          [field]: value
        }
      }
    },
    onAddFAQ: (state) => {
      if (state.faqs && state.faqs.faqs.length < MAX_FAQS) {
        state.faqs.faqs.push({ title: '', description: '' })
      }
    },
    onResetFAQsDetail: (state, action: PayloadAction<number>) => {
      const index = action.payload
      if (state.faqs) {
        state.faqs.faqs[index] = {
          title: '',
          description: ''
        }
      }
    },
    onDeleteFAQsDetail: (state, action: PayloadAction<number>) => {
      const index = action.payload
      if (state.faqs) {
        state.faqs.faqs.splice(index, 1)
      }
    },
    resetFAQState: () => initialState
  },
  extraReducers: (builder) => {
    builder
      .addCase(FaqService.getFAQsAsyncThunk.pending, (state) => {
        state.isGetAllFAQsLoading = true
      })
      .addCase(FaqService.getFAQsAsyncThunk.rejected, (state) => {
        state.isGetAllFAQsLoading = false
      })
      .addCase(FaqService.getFAQsAsyncThunk.fulfilled, (state, action) => {
        state.isGetAllFAQsLoading = false
        state.faqs = action.payload.faq
      })
      .addCase(FaqService.createOrUpdateFAQsAsyncThunk.pending, (state) => {
        state.isCreateOrUpdateFAQLoading = true
      })
      .addCase(FaqService.createOrUpdateFAQsAsyncThunk.rejected, (state) => {
        state.isCreateOrUpdateFAQLoading = false
      })
      .addCase(FaqService.createOrUpdateFAQsAsyncThunk.fulfilled, (state) => {
        state.isCreateOrUpdateFAQLoading = false
      })
  }
})

export const { onResetFAQsDetail, resetFAQState, onDeleteFAQsDetail, onAddFAQ, onChangeFAQ } = slice.actions
export default slice.reducer
